export default __webpack_public_path__ + "static/media/10.1da84e6d.jpg";